import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const { t } = useTranslation('pharmacies');

  return (
    <section className="relative bg-gradient-to-br from-blue-50 to-indigo-100 py-20 lg:py-32 overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/1012dd0769a227a2483f8bb92a3b8bdd.jpg')`
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/20 to-indigo-900/20" />
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-left">
            <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              {t('hero.title')}
            </h1>
            <p className="text-xl text-gray-700 mb-8 leading-relaxed">
              {t('hero.subtitle')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                {t('hero.cta')}
              </button>
              <button className="border-2 border-blue-600 text-blue-600 px-8 py-4 rounded-lg font-semibold hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer">
                {t('hero.learnMore')}
              </button>
            </div>
          </div>
          
          <div className="relative">
            <div className="bg-white rounded-2xl shadow-2xl p-8">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-shield-check-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Cumplimiento HIPAA</h3>
                  <p className="text-gray-600">100% Seguro y Conforme</p>
                </div>
              </div>
              
              <div className="space-y-4">
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700">Seguimiento de Sustancias Controladas</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700">Reconciliación de Seguros y PBM</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700">Preparación de Auditorías DEA</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700">Informes de Cumplimiento Regulatorio</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;